import { getCart, getOrder } from '@/services/FramedCheckout/orderServices'
import { updateShippingAddress } from '@/services/FramedCheckout/shipmentServices'
import { log } from '@/services/Log'
import { applePayPaymentContactToStandardAddress } from '../transformers/applePayPaymentContactToStandardAddress'
import type { ApplePayHandlerBuilderInput } from '../types'
import { withSessionCancelationHandling } from './withSessionCancelationHandling'

const informSessionOfStatus = (session: ApplePaySession) => (order: {
  shippingMethods: ApplePayJS.ApplePayShippingMethod[],
  total: ApplePayJS.ApplePayLineItem,
  lineItems: ApplePayJS.ApplePayLineItem[]
}) => (status: number) => {
  session.completeShippingContactSelection(
    status,
    order.shippingMethods,
    order.total,
    order.lineItems,
  )
}
const rawShippingHandler = ({
  session,
  beforeInitialize,
  onAbort,
  orderParser,
}: ApplePayHandlerBuilderInput) => async (
  event: ApplePayJS.ApplePayShippingContactSelectedEvent,
) => {
  log('Apple Pay onshippingcontactselected: ', event)
  if (beforeInitialize) {
    await beforeInitialize()
  }
  if (event.shippingContact) {
    const newAddress = applePayPaymentContactToStandardAddress(event.shippingContact)
    const cart = await getCart()
    if (!cart) {
      await onAbort()
    } else {
      const order = await getOrder({ cart })
      if (!newAddress.zip || newAddress.country !== 'US') {
        log('STATUS_INVALID_SHIPPING_CONTACTß')
        informSessionOfStatus(session)(
          orderParser(order),
        )(ApplePaySession.STATUS_INVALID_SHIPPING_CONTACT)
        throw new Error('Invalid Shipping address')
      } else {
        const { success, newOrder } = await updateShippingAddress({ address: newAddress, order })
        if (
          success
            && newOrder
            && newOrder?.shipments?.[0]?.availableShippingOptions.length > 0
        ) {
          informSessionOfStatus(session)(
            orderParser(newOrder),
          )(ApplePaySession.STATUS_SUCCESS)
        } else {
          informSessionOfStatus(session)(
            orderParser(order),
          )(ApplePaySession.STATUS_FAILURE)
        }
      }
    }
  }
}

export const handleShippingAddressSelected = withSessionCancelationHandling(rawShippingHandler)

export default handleShippingAddressSelected
